import type { LevelOpenFullDoors } from "building-types/doors/levelOpenFullDoors";
import type { OpeningPlacementFuncOptionsLiteRoomStartDefined } from "../../elements/openings/openingPlacementFuncOptions";

export function roomTypeOpenFullAdd(
  selectedPlacementOptions: OpeningPlacementFuncOptionsLiteRoomStartDefined,
  openFullDoors: LevelOpenFullDoors,
  levelId: string,
) {
  const levelOpenFullDoors: LevelOpenFullDoors = openFullDoors[levelId] || {};
  const halfEdge = selectedPlacementOptions.halfEdgeIndex;
  const startRoomId = selectedPlacementOptions.roomStart.id;
  const endRoomId = selectedPlacementOptions.roomEnd?.id;
  levelOpenFullDoors[halfEdge] = { startRoomId, endRoomId };
  openFullDoors[levelId] = levelOpenFullDoors;
}
